import BlogFilterning from "./blog-filtering";
import BlogPaginationLight from "./blog-pagination";
import BlogTopSection from "./blog-top-section";
import BreadcrumbsSection from "./breadcrumbs-section";

export default function BlogInnerSection() {
	return (
		<div className="fugu--inner-section light-version">
			<div className="container">
				<BreadcrumbsSection />
				<BlogTopSection />
				<BlogFilterning />
				<BlogPaginationLight />
			</div>
		</div>
	);
}
